<template>
    <v-dialog
        v-model="localDialog"
        width="50%"
        @update:modelValue="updateDialog"
        transition=""
        persistent
        :open-delay="0"
        :close-delay="0"
    >
        <base-card
      :title="isEntryMode ? 'Add Asset Category' : 'Update Asset Category'"
      :v-card-text-class="'pa-4'"
    >
<v-form @submit.prevent="submit" ref="AssetCategorySetup">
                    <v-row>
                        <v-col lg="6" md="6" cols="12">
                            <v-text-field
                            density="compact" 
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="name.value.value"
                            :error-messages="name.errorMessage.value"
                            clearable
                            >
                                <template #label>
                                Name <span class="text-red-accent-4">*</span>
                                </template>
                            </v-text-field>

                            <v-autocomplete
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            v-model="asset_depreciation_method_id.value.value"
                            :items="getAssetDepreciationMethodList"
                            :item-title="(item) => item.name"                                                 
                            item-value="id"
                            :error-messages="asset_depreciation_method_id.errorMessage.value"
                            :loading="depreciation_loading"
                            clearable                        

                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                <template #label>
                                Asset Depreciation Method <span class="text-red-accent-4">*</span>
                                </template>
                            </v-autocomplete> 

                            <v-checkbox
                            label="Active"
                            v-model="status.value.value"
                            :error-messages="status.errorMessage.value"
                            density="compact"
                            variant="outlined"
                            hide-details
                            single-line
                            color="primary"
                            value="1"
                            ></v-checkbox>
                        </v-col>

                        <v-col lg="6" md="6" cols="12">
                            <v-text-field
                            label="Depreciation Rate"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="depreciation_rate.value.value"
                            :error-messages="depreciation_rate.errorMessage.value"
                            clearable   
                            >
                                <template #label>
                                    Depreciation Rate<span class="text-red-accent-4">*</span>
                                </template>
                            </v-text-field>

                            <v-textarea
                            label="Remarks (Optional)"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="remarks.value.value"
                            :error-messages="remarks.errorMessage.value"
                            clearable
                            auto-grow
                            rows="1"
                            ></v-textarea>
                        </v-col>

                    </v-row>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-layout class="justify-end">
                            <v-btn
                            class="bg-red"
                            variant="flat"
                            type="reset"
                            @click="closeDialog"
                            >Close</v-btn>
                            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                                {{ isEntryMode ? "Save" : "Update" }}
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </base-card>
    </v-dialog>
</template>

<script>
import baseCard from '@/components/utils/baseCard.vue';
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";

export default {
  components: { baseCard },
    name: "Asset Categories",
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({
                asset_category_id: null,
                name: "",
                asset_depreciation_method_id: "",
                depreciation_rate:"",
                remarks: "",
                status: "1",
            }),
        },
    },
    data() {
        return {
            localDialog: this.dialog,
            errorMessages: "",
            preview: "/src/assets/no_preview.jpeg",
            loading: false,
            isEntryMode: true,
            depreciation_loading: false,
        };
    },
    computed: {
        getAssetDepreciationMethodList() {
            const data = this.$store.getters.getAssetDepreciationMethodList;
            return data;
        }
    },
    watch: {
        dialog(val) {
            this.localDialog = val;
        },
        localDialog(val) {
            this.$emit("update:dialog", val);
        },
        data: {
            handler(newData) {
                this.isEntryMode = !newData.id;
                this.resetForm({ errors: {}, touched: {} });
                this.asset_category_id.setValue(newData.id || null, false);
                this.name.setValue(newData.name || "", false);
                this.depreciation_rate.setValue(newData.depreciation_rate || "", false);
                this.asset_depreciation_method_id.setValue(newData.asset_depreciation_method_id || null, false);
                this.remarks.setValue(newData.remarks || "", false);
                this.status.setValue(String(newData.status) || "1", false);
            }
        },
    },
    created() {
        // if(this.$store.getters.getAssetDepreciationMethodList.length === 0){
            this.depreciation_loading = true;
            this.$store.dispatch("getAssetDepreciationMethodList").then((response) => {
                this.depreciation_loading=false;
            });
        // }
    },
    methods: {
        updateDialog(val) {
            this.$emit("update:dialog", val);
        },
        closeDialog() {
            this.$emit("update:dialog", false);
        },
    },
    setup(props, { emit }) {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                name: yup.string().min(1).max(50).required().trim().label("Name"),
                asset_depreciation_method_id: yup.string().required().trim().label("Depreciation method"),
                remarks: yup.string().max(250).nullable().trim().label("Remarks"),
                depreciation_rate: yup.number().required().typeError("Depreciation Rate must be a number").min(1).label("Depreciation Rate"),
            }),
        });

        const asset_category_id = useField("asset_category_id");
        const name = useField("name");
        const depreciation_rate = useField("depreciation_rate");
        const asset_depreciation_method_id = useField("asset_depreciation_method_id");
        const remarks = useField("remarks");
        const status = useField("status");
        const errorMessages = ref("");
        const loading = ref("");
        const store = useStore();

        const submit = handleSubmit((values) => {
        store
            .dispatch("saveUpdateAssetCategory", values)
            .then((response) => {
                resetForm();
                emit("update:dialog", false);
                toast.success(response.data.message);
                loading.value = true;
                store
                    .dispatch("getAssetCategoryList")
                    .then((data) => {
                        loading.value = false;
                    })
                    .catch((error) => {
                        loading.value = false;
                        toast.error(error.response.data.message);
                    });
            })
            .catch((error) => {
                toast.error(error.response.data.message);
            });
        });
        return {
            submit,
            asset_category_id,
            name,
            remarks,
            depreciation_rate,
            asset_depreciation_method_id,
            status,
            errorMessages,
            resetForm,
            loading,
        };
    },
    mounted() {},

}

</script>
